/**
 * Funkcinės Terapijos Centras — Kaklo problemų identifikavimas
 * Self-injecting widget. Embed with:
 *
 *   Place <div id="ftc-neck-checker"></div> in your blog post HTML.
 *   Load via Liquid: {{ 'ftc-neck.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var scriptTag = document.currentScript;
  var KLAVIYO_COMPANY_ID = scriptTag.getAttribute('data-klaviyo-id') || 'WGyTS6';
  var KLAVIYO_LIST_ID = scriptTag.getAttribute('data-list-id') || 'TBj684';
  var BOOKING_URL = scriptTag.getAttribute('data-booking-url') || 'https://funkcinesterapijoscentras.lt/pages/registracija';

  // ── Inject CSS ──
  var css = document.createElement('style');
  css.textContent = '' +
    '.ftcn *,.ftcn *::before,.ftcn *::after{box-sizing:border-box;margin:0;padding:0}' +
    '.ftcn{font-family:"Segoe UI",system-ui,-apple-system,sans-serif;max-width:640px;margin:40px auto;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(30,126,186,.18);background:#fff}' +
    '.ftcn-header{background:linear-gradient(135deg,#1E7EBA 0%,#1a6da3 100%);padding:32px 28px 24px;text-align:center;position:relative;overflow:hidden}' +
    '.ftcn-header::before{content:"";position:absolute;top:-40%;right:-20%;width:260px;height:260px;background:rgba(0,190,195,.12);border-radius:50%}' +
    '.ftcn-header::after{content:"";position:absolute;bottom:-30%;left:-10%;width:180px;height:180px;background:rgba(255,255,255,.06);border-radius:50%}' +
    '.ftcn-header h2{color:#fff;font-size:22px;font-weight:700;margin-bottom:6px;position:relative;z-index:1;line-height:1.3}' +
    '.ftcn-header p{color:rgba(255,255,255,.85);font-size:14px;position:relative;z-index:1}' +
    '.ftcn-badge{display:inline-block;background:rgba(0,190,195,.25);color:#fff;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:1.2px;padding:4px 14px;border-radius:20px;margin-bottom:12px;position:relative;z-index:1}' +
    '.ftcn-progress-wrap{padding:0 28px;margin-top:-8px;position:relative;z-index:2}' +
    '.ftcn-progress-bar{height:6px;background:#e8f0f5;border-radius:3px;overflow:hidden;margin-top:16px}' +
    '.ftcn-progress-fill{height:100%;background:linear-gradient(90deg,#00BEC3,#1E7EBA);border-radius:3px;transition:width .5s cubic-bezier(.4,0,.2,1);width:0%}' +
    '.ftcn-step-count{text-align:center;font-size:12px;color:#7a9bb5;margin-top:8px;font-weight:500}' +
    '.ftcn-body{padding:24px 28px 28px;min-height:320px;position:relative}' +
    '.ftcn-intro{text-align:center}' +
    '.ftcn-intro-icon{width:72px;height:72px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px}' +
    '.ftcn-intro-icon svg{width:36px;height:36px;color:#1E7EBA}' +
    '.ftcn-intro h3{font-size:18px;color:#1a2e3d;margin-bottom:10px;font-weight:600}' +
    '.ftcn-intro p{font-size:14px;color:#5a7080;line-height:1.6;margin-bottom:8px}' +
    '.ftcn-intro-list{text-align:left;margin:16px auto;max-width:380px}' +
    '.ftcn-intro-list-item{display:flex;align-items:flex-start;gap:10px;padding:8px 0;font-size:13px;color:#3d5a6e}' +
    '.ftcn-intro-list-item .ftcn-check{width:20px;height:20px;min-width:20px;background:#00BEC3;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-top:1px}' +
    '.ftcn-intro-list-item .ftcn-check svg{width:12px;height:12px;color:#fff}' +
    '.ftcn-slide{display:none;animation:ftcnFadeIn .4s ease}' +
    '.ftcn-slide.active{display:block}' +
    '@keyframes ftcnFadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}' +
    '.ftcn-question-num{font-size:12px;font-weight:600;color:#00BEC3;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px}' +
    '.ftcn-question-text{font-size:17px;color:#1a2e3d;font-weight:600;margin-bottom:6px;line-height:1.4}' +
    '.ftcn-question-hint{font-size:13px;color:#7a9bb5;margin-bottom:24px;line-height:1.5}' +
    '.ftcn-options{display:flex;flex-direction:column;gap:10px;margin-top:4px}' +
    '.ftcn-option{display:flex;align-items:center;gap:12px;padding:14px 16px;border:2px solid #e8f0f5;border-radius:12px;cursor:pointer;transition:all .25s ease;background:#fff}' +
    '.ftcn-option:hover{border-color:#b8dce8;background:#f6fbfd}' +
    '.ftcn-option.selected{border-color:#00BEC3;background:#e6f9fa}' +
    '.ftcn-option-radio{width:22px;height:22px;min-width:22px;border-radius:50%;border:2px solid #c8d8e2;display:flex;align-items:center;justify-content:center;transition:all .25s ease}' +
    '.ftcn-option.selected .ftcn-option-radio{border-color:#00BEC3;background:#00BEC3}' +
    '.ftcn-option.selected .ftcn-option-radio::after{content:"";width:8px;height:8px;background:#fff;border-radius:50%}' +
    '.ftcn-option-text{font-size:14px;color:#2a4050;font-weight:500}' +
    '.ftcn-slider-wrap{padding:12px 0 8px}' +
    '.ftcn-slider-labels{display:flex;justify-content:space-between;margin-bottom:12px}' +
    '.ftcn-slider-label{font-size:12px;font-weight:500;padding:6px 12px;border-radius:8px;transition:all .3s ease;max-width:45%;text-align:center;line-height:1.3}' +
    '.ftcn-slider-label.left{color:#27ae60;background:#e8f8ef}' +
    '.ftcn-slider-label.right{color:#c0392b;background:#fce8e6}' +
    '.ftcn-range-track{position:relative;height:48px;display:flex;align-items:center}' +
    '.ftcn-range{-webkit-appearance:none;appearance:none;width:100%;height:8px;border-radius:4px;background:linear-gradient(90deg,#27ae60,#e0e8ed 50%,#e05555);outline:none;cursor:pointer}' +
    '.ftcn-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer;transition:transform .2s ease,box-shadow .2s ease}' +
    '.ftcn-range::-webkit-slider-thumb:hover{transform:scale(1.15);box-shadow:0 3px 14px rgba(0,190,195,.4)}' +
    '.ftcn-range::-moz-range-thumb{width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer}' +
    '.ftcn-range-value{text-align:center;margin-top:8px;font-size:13px;font-weight:600;color:#1E7EBA;min-height:20px}' +
    '.ftcn-buttons{display:flex;justify-content:space-between;align-items:center;margin-top:28px;gap:12px}' +
    '.ftcn-btn{padding:12px 28px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;border:none;transition:all .3s ease;display:inline-flex;align-items:center;gap:6px}' +
    '.ftcn-btn-primary{background:linear-gradient(135deg,#00BEC3,#00a8ad);color:#fff;box-shadow:0 4px 14px rgba(0,190,195,.3)}' +
    '.ftcn-btn-primary:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcn-btn-secondary{background:transparent;color:#7a9bb5;border:2px solid #e0e8ed}' +
    '.ftcn-btn-secondary:hover{border-color:#b8d0dd;color:#5a7a90}' +
    '.ftcn-btn-large{width:100%;justify-content:center;padding:14px 28px;font-size:15px}' +
    '.ftcn-btn svg{width:16px;height:16px}' +
    '.ftcn-email-gate{text-align:center}' +
    '.ftcn-email-gate h3{font-size:18px;color:#1a2e3d;margin-bottom:8px;font-weight:600}' +
    '.ftcn-email-gate p{font-size:14px;color:#5a7080;margin-bottom:20px;line-height:1.5}' +
    '.ftcn-email-icon{width:64px;height:64px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px}' +
    '.ftcn-email-icon svg{width:30px;height:30px;color:#1E7EBA}' +
    '.ftcn-input-wrap{position:relative;margin-bottom:12px}' +
    '.ftcn-input{width:100%;padding:14px 16px;border:2px solid #e0e8ed;border-radius:10px;font-size:14px;font-family:inherit;color:#2a4050;outline:none;transition:border-color .3s ease;background:#fff}' +
    '.ftcn-input:focus{border-color:#00BEC3}' +
    '.ftcn-input::placeholder{color:#a8bcc8}' +
    '.ftcn-email-note{font-size:11px;color:#a0b0bb;margin-top:8px}' +
    '.ftcn-email-error{color:#e05555;font-size:12px;margin-top:4px;display:none}' +
    '.ftcn-results{text-align:center}' +
    '.ftcn-result-circle-wrap{position:relative;width:160px;height:160px;margin:0 auto 20px}' +
    '.ftcn-result-circle{width:160px;height:160px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;z-index:1}' +
    '.ftcn-result-circle.muscle{background:linear-gradient(135deg,#e8f8ef,#d0f0db);border:3px solid #27ae60}' +
    '.ftcn-result-circle.disc{background:linear-gradient(135deg,#fce8e6,#f5d0cd);border:3px solid #c0392b}' +
    '.ftcn-result-circle.osteo{background:linear-gradient(135deg,#e6f0fa,#cce0f5);border:3px solid #2c5282}' +
    '.ftcn-result-circle.posture{background:linear-gradient(135deg,#fff4e6,#ffe8cc);border:3px solid #e8a04c}' +
    '.ftcn-result-type{font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:1px;margin-bottom:2px}' +
    '.ftcn-result-label{font-size:16px;font-weight:700;text-align:center;line-height:1.2;padding:0 8px}' +
    '.ftcn-result-circle.muscle .ftcn-result-type{color:#1e8449}.ftcn-result-circle.muscle .ftcn-result-label{color:#1a7a40}' +
    '.ftcn-result-circle.disc .ftcn-result-type{color:#922b21}.ftcn-result-circle.disc .ftcn-result-label{color:#7b241c}' +
    '.ftcn-result-circle.osteo .ftcn-result-type{color:#2c5282}.ftcn-result-circle.osteo .ftcn-result-label{color:#1a365d}' +
    '.ftcn-result-circle.posture .ftcn-result-type{color:#c46b20}.ftcn-result-circle.posture .ftcn-result-label{color:#a35a18}' +
    '.ftcn-result-text{font-size:15px;color:#2a4050;line-height:1.6;margin-bottom:16px;max-width:480px;margin-left:auto;margin-right:auto}' +
    '.ftcn-result-detail{background:#f6f9fb;border-radius:12px;padding:16px 20px;margin-bottom:20px;text-align:left}' +
    '.ftcn-result-detail h4{font-size:14px;font-weight:600;color:#1a2e3d;margin-bottom:8px}' +
    '.ftcn-result-detail p{font-size:13px;color:#5a7080;line-height:1.5}' +
    '.ftcn-result-cta,.ftcn-result-cta:visited,.ftcn-result-cta:active,.ftcn-result-cta:hover{background:#00BEC3;color:#fff !important;padding:14px 32px;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;border:none;display:inline-flex;align-items:center;gap:8px;transition:all .3s ease;box-shadow:0 4px 14px rgba(0,190,195,.3);text-decoration:none !important}' +
    '.ftcn-result-cta:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftcn-result-cta svg{width:18px;height:18px}' +
    '.ftcn-disclaimer{font-size:11px;color:#a0b0bb;margin-top:16px;line-height:1.4;padding-top:12px;border-top:1px solid #eef2f5}' +
    '@media(max-width:480px){.ftcn{margin:16px 8px;border-radius:12px}.ftcn-header{padding:24px 20px 18px}.ftcn-header h2{font-size:19px}.ftcn-body{padding:20px 20px 24px}.ftcn-progress-wrap{padding:0 20px}.ftcn-slider-label{font-size:11px;padding:4px 8px}.ftcn-buttons{flex-direction:column-reverse}.ftcn-btn{width:100%;justify-content:center}}';
  document.head.appendChild(css);

  // ── SVG helpers ──
  var svgArrowRight = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>';
  var svgArrowLeft  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12"/></svg>';
  var svgCheck      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/></svg>';
  var svgCheckSmall = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
  var svgMail       = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>';
  var svgCalendar   = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>';
  var svgNeck       = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>';

  // ── Build HTML ──
  var html = '' +
    '<div class="ftcn-header">' +
      '<div class="ftcn-badge">Nemokamas testas</div>' +
      '<h2>Kas sukelia j\u016bs\u0173 kaklo skausm\u0105?</h2>' +
      '<p>Kaklo problem\u0173 identifikavimo testas</p>' +
    '</div>' +
    '<div class="ftcn-progress-wrap" id="ftcnProgressWrap" style="display:none;">' +
      '<div class="ftcn-progress-bar"><div class="ftcn-progress-fill" id="ftcnProgressFill"></div></div>' +
      '<div class="ftcn-step-count" id="ftcnStepCount"></div>' +
    '</div>' +
    '<div class="ftcn-body">' +

      // Intro
      '<div class="ftcn-slide active" id="ftcnIntro"><div class="ftcn-intro">' +
        '<div class="ftcn-intro-icon">' + svgNeck + '</div>' +
        '<h3>Nustatykite savo kaklo skausmo prie\u017east\u012f</h3>' +
        '<p>Atsakykite \u012f 5 klausimus ir su\u017einokite, kokia problema labiausiai tik\u0117tina jūsų atveju.</p>' +
        '<div class="ftcn-intro-list">' +
          '<div class="ftcn-intro-list-item"><div class="ftcn-check">' + svgCheckSmall + '</div><span>U\u017etrunka tik 2 minutes</span></div>' +
          '<div class="ftcn-intro-list-item"><div class="ftcn-check">' + svgCheckSmall + '</div><span>Paremtas klinikini\u0173 vertinimo kriterij\u0173</span></div>' +
          '<div class="ftcn-intro-list-item"><div class="ftcn-check">' + svgCheckSmall + '</div><span>Gausite asmenin\u0119 rekomendacij\u0105</span></div>' +
        '</div>' +
        '<button class="ftcn-btn ftcn-btn-primary ftcn-btn-large" id="ftcnStartBtn">Prad\u0117ti test\u0105 ' + svgArrowRight + '</button>' +
      '</div></div>' +

      // Q1 — Pain location
      '<div class="ftcn-slide" id="ftcnQ1">' +
        '<div class="ftcn-question-num">1 klausimas i\u0161 5</div>' +
        '<div class="ftcn-question-text">Kur jau\u010diate kaklo skausm\u0105?</div>' +
        '<div class="ftcn-question-hint">Skausmo vieta padeda nustatyti galim\u0105 prie\u017east\u012f.</div>' +
        '<div class="ftcn-options" id="ftcnO1">' +
          '<div class="ftcn-option" data-m="25" data-d="10" data-o="10" data-p="15"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Abiejose pus\u0117se vienodai (kaklo viduryje)</div></div>' +
          '<div class="ftcn-option" data-m="15" data-d="20" data-o="15" data-p="10"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Vienoje pus\u0117je (de\u0161in\u0117je arba kair\u0117je)</div></div>' +
          '<div class="ftcn-option" data-m="10" data-d="5" data-o="25" data-p="15"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Kaklo apačioje, pereina \u012f pe\u010dius</div></div>' +
          '<div class="ftcn-option" data-m="10" data-d="25" data-o="15" data-p="5"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Kakle su plitimu \u012f rank\u0105 ar galv\u0105</div></div>' +
        '</div>' +
      '</div>' +

      // Q2 — Radiation to arm/hand
      '<div class="ftcn-slide" id="ftcnQ2">' +
        '<div class="ftcn-question-num">2 klausimas i\u0161 5</div>' +
        '<div class="ftcn-question-text">Ar skausmas plinta \u012f rank\u0105 ar pir\u0161tus?</div>' +
        '<div class="ftcn-question-hint">Skausmo plitimas gali rodyti nerv\u0173 strukt\u016br\u0173 pa\u017eeidim\u0105.</div>' +
        '<div class="ftcn-options" id="ftcnO2">' +
          '<div class="ftcn-option" data-m="25" data-d="5" data-o="15" data-p="15"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Ne, skausmas tik kakle</div></div>' +
          '<div class="ftcn-option" data-m="10" data-d="15" data-o="20" data-p="10"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Kartais plinta \u012f pet\u012f ar \u017east\u0105</div></div>' +
          '<div class="ftcn-option" data-m="5" data-d="30" data-o="10" data-p="5"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Taip, reguliariai plinta \u012f rank\u0105 ar pir\u0161tus</div></div>' +
          '<div class="ftcn-option" data-m="5" data-d="35" data-o="5" data-p="5"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Plinta ir jau\u010diu tirpim\u0105 ar silpnum\u0105 rankoje</div></div>' +
        '</div>' +
      '</div>' +

      // Q3 — Numbness / stiffness
      '<div class="ftcn-slide" id="ftcnQ3">' +
        '<div class="ftcn-question-num">3 klausimas i\u0161 5</div>' +
        '<div class="ftcn-question-text">Kokie papildomi simptomai jus vargina?</div>' +
        '<div class="ftcn-question-hint">Lydinys simptomai padeda tiksliau nustatyti problem\u0105.</div>' +
        '<div class="ftcn-options" id="ftcnO3">' +
          '<div class="ftcn-option" data-m="30" data-d="5" data-o="10" data-p="10"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Raumen\u0173 \u012ftampa ir sustingimas</div></div>' +
          '<div class="ftcn-option" data-m="5" data-d="30" data-o="10" data-p="5"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Tirpimas, dilg\u010diojimas ar \u201ebėgančios srovės\u201c jausmas</div></div>' +
          '<div class="ftcn-option" data-m="5" data-d="10" data-o="30" data-p="10"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Ribotas kaklo judrumas, trakš\u0117jimas</div></div>' +
          '<div class="ftcn-option" data-m="10" data-d="5" data-o="10" data-p="30"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Galvos skausmas, nuovargis, \u012ftampa pečiuose</div></div>' +
        '</div>' +
      '</div>' +

      // Q4 — Posture / screen time
      '<div class="ftcn-slide" id="ftcnQ4">' +
        '<div class="ftcn-question-num">4 klausimas i\u0161 5</div>' +
        '<div class="ftcn-question-text">Kokia jūsų kasdien\u0117 laikysena?</div>' +
        '<div class="ftcn-question-hint">Laikysena ir veiklos pobūdis turi didelę \u012ftak\u0105 kaklo sveikatai.</div>' +
        '<div class="ftcn-options" id="ftcnO4">' +
          '<div class="ftcn-option" data-m="10" data-d="5" data-o="5" data-p="35"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Daug valand\u0173 prie ekrano, s\u0117dimas darbas</div></div>' +
          '<div class="ftcn-option" data-m="15" data-d="5" data-o="15" data-p="20"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Mišrus — ir s\u0117d\u017eiu, ir judu</div></div>' +
          '<div class="ftcn-option" data-m="20" data-d="10" data-o="15" data-p="5"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Fizinis darbas, dažnas k\u0117limas</div></div>' +
          '<div class="ftcn-option" data-m="5" data-d="15" data-o="20" data-p="10"><div class="ftcn-option-radio"></div><div class="ftcn-option-text">Skausmas atsirado po traumos ar nelaimingo atsitikimo</div></div>' +
        '</div>' +
      '</div>' +

      // Q5 — Pain intensity slider
      '<div class="ftcn-slide" id="ftcnQ5">' +
        '<div class="ftcn-question-num">5 klausimas i\u0161 5</div>' +
        '<div class="ftcn-question-text">Koks yra jūsų kaklo skausmo stiprumas?</div>' +
        '<div class="ftcn-question-hint">\u012evertinkite vidutin\u012f skausmo lyg\u012f per pastar\u0105j\u0105 savait\u0119.</div>' +
        '<div class="ftcn-slider-wrap"><div class="ftcn-slider-labels"><span class="ftcn-slider-label left">Silpnas, pakenčiamas</span><span class="ftcn-slider-label right">Stiprus, nuolatinis</span></div>' +
        '<div class="ftcn-range-track"><input type="range" class="ftcn-range" id="ftcnR5" min="0" max="100" value="50"></div>' +
        '<div class="ftcn-range-value" id="ftcnV5"></div></div>' +
      '</div>' +

      // Email gate
      '<div class="ftcn-slide" id="ftcnEmail"><div class="ftcn-email-gate">' +
        '<div class="ftcn-email-icon">' + svgMail + '</div>' +
        '<h3>Jūsų rezultatai paruošti!</h3>' +
        '<p>\u012eveskite savo el. pa\u0161t\u0105 ir gaukite detalią kaklo problemos analizę bei patarimus.</p>' +
        '<div class="ftcn-input-wrap"><input type="email" class="ftcn-input" id="ftcnEmailInput" placeholder="j\u016bs\u0173@elpa\u0161tas.lt"><div class="ftcn-email-error" id="ftcnEmailError">\u012eveskite teising\u0105 el. pašto adres\u0105</div></div>' +
        '<button class="ftcn-btn ftcn-btn-primary ftcn-btn-large" id="ftcnEmailBtn">Gauti rezultatus ' + svgCheck + '</button>' +
        '<div class="ftcn-email-note">Gal\u0117site bet kada atsisakyti naujienlaiškio.</div>' +
      '</div></div>' +

      // Results
      '<div class="ftcn-slide" id="ftcnResults"><div class="ftcn-results">' +
        '<div class="ftcn-result-circle-wrap"><div class="ftcn-result-circle" id="ftcnResultCircle"><div class="ftcn-result-type" id="ftcnResultType"></div><div class="ftcn-result-label" id="ftcnResultLabel"></div></div></div>' +
        '<div class="ftcn-result-text" id="ftcnResultText"></div>' +
        '<div class="ftcn-result-detail" id="ftcnResultDetail"><h4 id="ftcnDetailTitle"></h4><p id="ftcnDetailText"></p></div>' +
        '<a class="ftcn-result-cta" href="' + BOOKING_URL + '" target="_blank">Registruotis konsultacijai ' + svgCalendar + '</a>' +
        '<div class="ftcn-disclaimer">\u0160is klausimynas yra informacinio pob\u016bd\u017eio ir nepakeičia profesionalaus gydytojo ar kineziterapeuto konsultacijos.</div>' +
      '</div></div>' +

      // Nav
      '<div class="ftcn-buttons" id="ftcnNav" style="display:none;">' +
        '<button class="ftcn-btn ftcn-btn-secondary" id="ftcnBtnBack">' + svgArrowLeft + ' Atgal</button>' +
        '<button class="ftcn-btn ftcn-btn-primary" id="ftcnBtnNext">Kitas ' + svgArrowRight + '</button>' +
      '</div>' +

    '</div>';

  // ── Mount ──
  var target = document.getElementById('ftc-neck-checker');
  if (!target) return;
  var root = document.createElement('div');
  root.className = 'ftcn';
  root.id = 'ftcnChecker';
  root.innerHTML = html;
  target.appendChild(root);

  // ── State ──
  var currentStep = 0;
  var totalSteps = 5;
  var scores = { m: 0, d: 0, o: 0, p: 0 }; // muscle, disc, osteo, posture
  var selectedOpts = {};
  var sliderVal = 50;

  var nav          = document.getElementById('ftcnNav');
  var progressWrap = document.getElementById('ftcnProgressWrap');
  var backBtn      = document.getElementById('ftcnBtnBack');
  var nextBtn      = document.getElementById('ftcnBtnNext');
  var progressFill = document.getElementById('ftcnProgressFill');
  var stepCount    = document.getElementById('ftcnStepCount');

  // ── Event listeners ──
  document.getElementById('ftcnStartBtn').addEventListener('click', function () {
    currentStep = 1; showStep();
  });
  nextBtn.addEventListener('click', function () {
    // Only used for step 5 (slider) → go to email gate
    currentStep = 6;
    showStep();
  });
  backBtn.addEventListener('click', function () {
    currentStep = currentStep === 6 ? totalSteps : Math.max(1, currentStep - 1);
    showStep();
  });
  document.getElementById('ftcnEmailBtn').addEventListener('click', submitEmail);

  // Slider Q5
  document.getElementById('ftcnR5').addEventListener('input', function () { updateSlider(); });

  // Option cards Q1-Q4 (auto-advance)
  [1, 2, 3, 4].forEach(function (q) {
    document.querySelectorAll('#ftcnO' + q + ' .ftcn-option').forEach(function (el) {
      el.addEventListener('click', function () {
        if (selectedOpts[q]) {
          scores.m -= parseInt(selectedOpts[q].getAttribute('data-m'));
          scores.d -= parseInt(selectedOpts[q].getAttribute('data-d'));
          scores.o -= parseInt(selectedOpts[q].getAttribute('data-o'));
          scores.p -= parseInt(selectedOpts[q].getAttribute('data-p'));
        }
        scores.m += parseInt(el.getAttribute('data-m'));
        scores.d += parseInt(el.getAttribute('data-d'));
        scores.o += parseInt(el.getAttribute('data-o'));
        scores.p += parseInt(el.getAttribute('data-p'));
        selectedOpts[q] = el;
        el.parentElement.querySelectorAll('.ftcn-option').forEach(function (s) { s.classList.remove('selected'); });
        el.classList.add('selected');
        // Auto-advance after brief visual feedback
        setTimeout(function () {
          currentStep = q + 1;
          showStep();
        }, 350);
      });
    });
  });

  // ── Functions ──
  function updateSlider() {
    sliderVal = parseInt(document.getElementById('ftcnR5').value);
    var valEl = document.getElementById('ftcnV5');
    if (sliderVal < 20) valEl.textContent = 'Minimalus diskomfortas';
    else if (sliderVal < 40) valEl.textContent = 'Lengvas skausmas';
    else if (sliderVal < 60) valEl.textContent = 'Vidutinis skausmas';
    else if (sliderVal < 80) valEl.textContent = 'Stiprus skausmas';
    else valEl.textContent = 'Labai stiprus skausmas';
  }

  function getResult() {
    // Slider influence: high pain → boost disc and osteo
    var fm = scores.m + Math.round((100 - sliderVal) * 0.2);
    var fd = scores.d + Math.round(sliderVal * 0.3);
    var fo = scores.o + Math.round(sliderVal * 0.15);
    var fp = scores.p + Math.round((100 - sliderVal) * 0.1);
    if (fm >= fd && fm >= fo && fm >= fp) return 'muscle';
    if (fd >= fm && fd >= fo && fd >= fp) return 'disc';
    if (fo >= fm && fo >= fd && fo >= fp) return 'osteo';
    return 'posture';
  }

  function submitEmail() {
    var emailInput = document.getElementById('ftcnEmailInput');
    var email = emailInput.value.trim();
    var errorEl = document.getElementById('ftcnEmailError');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.style.display = 'block'; emailInput.style.borderColor = '#e05555'; return;
    }
    errorEl.style.display = 'none'; emailInput.style.borderColor = '#00BEC3';
    sendToKlaviyo(email);
    currentStep = 7; showStep(); computeResults();
  }

  function sendToKlaviyo(email) {
    if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) return;
    var resultType = getResult();
    var subData = {
      data: { type: 'subscription', attributes: { custom_source: 'Neck Pain Widget',
        profile: { data: { type: 'profile', attributes: { email: email },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(subData)
    }).then(function (r) { console.log('[FTC Neck] subscribe:', r.status); }).catch(function (e) { console.error('[FTC Neck]', e); });
// Also subscribe to combined widget list
subData.data.relationships.list.data.id = 'VfJCJm';
fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(subData)}).then(function(r){console.log('[FTC] combined:',r.status);}).catch(function(e){console.error(e);});
subData.data.relationships.list.data.id = KLAVIYO_LIST_ID;
resultType = {muscle:'Raumenų įtampa',disc:'Disko išvarža',osteo:'Osteochondrozė',posture:'Laikysenos problema'}[resultType] || resultType;
    var profileData = {
      data: { type: 'profile', attributes: { email: email, properties: {
        neck_pain_result: resultType,
        neck_pain_date: new Date().toISOString()
      } } }
    };
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(profileData)
    }).then(function (r) { console.log('[FTC Neck] profile:', r.status); }).catch(function (e) { console.error('[FTC Neck]', e); });
  }

  function computeResults() {
    var result = getResult();
    var circle = document.getElementById('ftcnResultCircle');
    var typeEl = document.getElementById('ftcnResultType');
    var labelEl = document.getElementById('ftcnResultLabel');
    var textEl = document.getElementById('ftcnResultText');
    var dTitle = document.getElementById('ftcnDetailTitle');
    var dText = document.getElementById('ftcnDetailText');
    circle.className = 'ftcn-result-circle';

    if (result === 'muscle') {
      circle.classList.add('muscle');
      typeEl.textContent = 'Tik\u0117tina';
      labelEl.textContent = 'Padidėjusi raumen\u0173 \u012ftampa';
      textEl.textContent = 'Jūsų simptomai labiausiai atitinka raumen\u0173 \u012ftamp\u0105 ir spazm\u0105 — da\u017eniausią kaklo skausmo prie\u017east\u012f, paprastai susijusi\u0105 su stresu, nuovargiu ar netinkama laikysena.';
      dTitle.textContent = 'Kas yra raumen\u0173 \u012ftampa?';
      dText.textContent = 'Kaklo raumen\u0173 \u012ftampa atsiranda d\u0117l ilgalaikio statinio kr\u016bvio, streso ar netinkamos laikysenos. Raumenys tampa \u012ftempti, skausmingi, gali formuotis trigeriniai skausmo taškai. Gera \u017einia — tai da\u017eniausiai gerai reaguoja \u012f kineziterapij\u0105, masa\u017e\u0105 ir laikysenos korekciją. Reguliar\u016bs pratimai ir darbo vietos ergonomika padeda  atsikratyti skausmo.';
    } else if (result === 'disc') {
      circle.classList.add('disc');
      typeEl.textContent = 'Tik\u0117tina';
      labelEl.textContent = 'Disko i\u0161var\u017ea';
      textEl.textContent = 'Jūsų simptomai gali rodyti kaklo srities disko i\u0161var\u017e\u0105 — b\u016bkl\u0119, kai tarpslankstelis diskas spaud\u017eia nerv\u0105, sukeliant skausm\u0105 ir simptomus rankoje.';
      dTitle.textContent = 'Kas yra disko i\u0161var\u017ea?';
      dText.textContent = 'Kaklo disko i\u0161var\u017ea (herniacija) atsiranda, kai mink\u0161tas disko branduolys i\u0161si\u0161ov\u0117 pro i\u0161orin\u012f \u017eied\u0105 ir spaud\u017eia nerv\u0173 \u0161aknel\u0119. Tai sukelia skausm\u0105 kakle, kuris plinta \u012f rank\u0105, tirpim\u0105 ir raumen\u0173 silpnum\u0105. Daugeliu atvejų konservatyvus gydymas — kineziterapija, mobilizacijos ir nervų slydimo pratimai — padeda sum\u0105\u017einti simptomus be operacijos.';
    } else if (result === 'osteo') {
      circle.classList.add('osteo');
      typeEl.textContent = 'Tik\u0117tina';
      labelEl.textContent = 'Osteochondroz\u0117';
      textEl.textContent = 'Jūsų simptomai gali rodyti kaklo osteochondroz\u0119 — degeneracinius stuburo pokyčius, sukelian\u010dius skausm\u0105, standum\u0105 ir ribotą judrumą.';
      dTitle.textContent = 'Kas yra kaklo osteochondroz\u0117?';
      dText.textContent = 'Kaklo osteochondroz\u0117 — tai l\u0117tinis degeneracinis procesas, paveikiantis tarpslankstelinius diskus ir s\u0105narius. Am\u017eiui b\u0117gant, diskai nusid\u0117vi, s\u0105nariai stand\u0117ja, gali formuotis osteofitai. Simptomai: kaklo standumas, trakš\u0117jimas, ribotas judrumas. Kineziterapija, reguliar\u016bs judumo pratimai ir laikysenos korekcija padeda sulėtinti procesą ir suma\u017einti simptomus.';
    } else {
      circle.classList.add('posture');
      typeEl.textContent = 'Tik\u0117tina';
      labelEl.textContent = 'Laikysenos problemos';
      textEl.textContent = 'Jūsų simptomai labiausiai atitinka laikysenos sukeltą kaklo skausmą — b\u016bkl\u0119, tiesiogiai susijusi\u0105 su s\u0117dimu darbu, ilgu \u017ei\u016br\u0117jimu \u012f ekran\u0105 ir netinkama galvos pad\u0117timi.';
      dTitle.textContent = 'Kaip laikysena veikia kaklą?';
      dText.textContent = 'Ilgas s\u0117d\u0117jimas prie kompiuterio ar telefono naudojimas veda prie \u201epriekin\u0117s galvos\u201c sindromo — galva pamažu slenka pirmyn, o kaklo raumenys yra perkraunami. Kiekvienas centimetras \u012f priek\u012f padidina kaklo apkrovą keliais kilogramais. Tai sukelia nuolatin\u0119 raumenų \u012ftamp\u0105, galvos skausmą ir pe\u010dių diskomfort\u0105. Kineziterapija, ergonomikos korekcija ir tiksliniai pratimai padeda atkurti tinkamą laikyseną ir pa\u0161alinti skausm\u0105.';
    }
  }

  function showStep() {
    var slides = document.querySelectorAll('#ftcnChecker .ftcn-slide');
    slides.forEach(function (s) { s.classList.remove('active'); });

    if (currentStep === 0) {
      document.getElementById('ftcnIntro').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    } else if (currentStep >= 1 && currentStep <= totalSteps) {
      document.getElementById('ftcnQ' + currentStep).classList.add('active');
      progressWrap.style.display = 'block';
      progressFill.style.width = Math.round((currentStep / totalSteps) * 100) + '%';
      stepCount.textContent = currentStep + ' i\u0161 ' + totalSteps + ' klausim\u0173';
      // Steps 1-4: auto-advance on click, hide Next; Step 5 (slider): show Next
      if (currentStep <= 4) {
        nav.style.display = currentStep === 1 ? 'none' : 'flex';
        nextBtn.style.display = 'none';
        backBtn.style.visibility = 'visible';
      } else {
        nav.style.display = 'flex';
        nextBtn.style.display = '';
        backBtn.style.visibility = 'visible';
        nextBtn.innerHTML = 'Gauti rezultatus ' + svgCheck;
        updateSlider();
      }
    } else if (currentStep === 6) {
      document.getElementById('ftcnEmail').classList.add('active');
      nav.style.display = 'flex'; progressWrap.style.display = 'block';
      progressFill.style.width = '100%';
      stepCount.textContent = 'Paskutinis \u017eingsnis';
      backBtn.style.visibility = 'visible'; nextBtn.style.display = 'none';
    } else if (currentStep === 7) {
      document.getElementById('ftcnResults').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    }
  }

})();